import React, { ChangeEvent, Component } from 'react';
import { TrackerEventVariable } from '../../../../domain/tracker/variable/TrackerVariable';
import FormicaLabel from '../../../custom/FormicaLabel';
import RoleHelper from '../../../../RoleHelper';
import FormicaInput from '../../../custom/FormicaInput';

class TrackerEventVariableComponent extends Component<Props> {
  public render() {
    const { variable } = this.props;
    return (
      <div>
        <div className={'border-b py-5'}>
          <div className={'flex flex-col gap-y-1'}>
            <FormicaLabel label={'CSS Selector'} />
            <FormicaInput value={variable.selection.cssSelector} onChange={this.onChangeCssSelector} disabled={!RoleHelper.canEdit('Tracker')} />
          </div>
        </div>
        <div className={'border-b py-5'}>
          <div className={'flex flex-col gap-y-1'}>
            <FormicaLabel label={'Attribute'} />
            <FormicaInput value={variable.selection.attribute} onChange={this.onChangeAttribute} disabled={!RoleHelper.canEdit('Tracker')} />
          </div>
        </div>
      </div>
    );
  }

  private onChangeCssSelector = (e: ChangeEvent<HTMLInputElement>) => {
    const { variable, onChange } = this.props;
    variable.selection.cssSelector = e.target.value;
    onChange(variable);
  };

  private onChangeAttribute = (e: ChangeEvent<HTMLInputElement>) => {
    const { variable, onChange } = this.props;
    variable.selection.attribute = e.target.value;
    onChange(variable);
  };
}

interface Props {
  variable: TrackerEventVariable;
  onChange: (variable: TrackerEventVariable) => void;
}

export default TrackerEventVariableComponent;
